export { default as useSubmitSelectedLifestylesToTask } from './useSubmitSelectedLifestylesToTask';
